// Recovered compiled webpack factory 47022. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n, a;
  r.d(t, { dp: () => eL, Nt: () => eU, Sx: () => eD });
  var o = r(2257),
    i = r(61571),
    s = r(88722),
    l = r(43275),
    u = r(90929),
    c = r(47434),
    f = r(43316),
    d = r(51290),
    p = r(87624),
    h = r(89135),
    _ = r(17588);
  class m {
    constructor(e = {}) {
      ((this._traceId = e.traceId || (0, _.e)()), (this._spanId = e.spanId || (0, _.Z)()));
    }
    spanContext() {
      return { spanId: this._spanId, traceId: this._traceId, traceFlags: d.CC };
    }
    end(e) {}
    setAttribute(e, t) {
      return this;
    }
    setAttributes(e) {
      return this;
    }
    setStatus(e) {
      return this;
    }
    updateName(e) {
      return this;
    }
    isRecording() {
      return !1;
    }
    addEvent(e, t, r) {
      return this;
    }
    addLink(e) {
      return this;
    }
    addLinks(e) {
      return this;
    }
    recordException(e, t) {}
  }
  var g = r(27123);
  function y(e) {
    if (!e || 0 === e.length) return;
    let t = {};
    return (
      e.forEach((e) => {
        let r = e.attributes || {},
          n = r[s.Sn],
          a = r[s.xc];
        "string" == typeof n && "number" == typeof a && (t[e.name] = { value: a, unit: n });
      }),
      t
    );
  }
  var v = r(20753);
  class b {
    constructor(e = {}) {
      ((this._traceId = e.traceId || (0, _.e)()),
        (this._spanId = e.spanId || (0, _.Z)()),
        (this._startTime = e.startTimestamp || (0, p.zf)()),
        (this._links = e.links),
        (this._attributes = {}),
        this.setAttributes({ [s.JD]: "manual", [s.uT]: e.op, ...e.attributes }),
        (this._name = e.name),
        e.parentSpanId && (this._parentSpanId = e.parentSpanId),
        "sampled" in e && (this._sampled = e.sampled),
        e.endTimestamp && (this._endTime = e.endTimestamp),
        (this._events = []),
        (this._isStandaloneSpan = e.isStandalone),
        this._endTime && this._onSpanEnded());
    }
    addLink(e) {
      return (this._links ? this._links.push(e) : (this._links = [e]), this);
    }
    addLinks(e) {
      return (this._links ? this._links.push(...e) : (this._links = e), this);
    }
    recordException(e, t) {}
    spanContext() {
      let { _spanId: e, _traceId: t, _sampled: r } = this;
      return { spanId: e, traceId: t, traceFlags: r ? d.aO : d.CC };
    }
    setAttribute(e, t) {
      return (void 0 === t ? delete this._attributes[e] : (this._attributes[e] = t), this);
    }
    setAttributes(e) {
      return (Object.keys(e).forEach((t) => this.setAttribute(t, e[t])), this);
    }
    updateStartTime(e) {
      this._startTime = (0, d.cI)(e);
    }
    setStatus(e) {
      return ((this._status = e), this);
    }
    updateName(e) {
      return ((this._name = e), this.setAttribute(s.i_, "custom"), this);
    }
    end(e) {
      this._endTime ||
        ((this._endTime = (0, d.cI)(e)),
        (function (e) {
          if (!i.T) return;
          let { description: t = "< unknown name >", op: r = "< unknown op >" } = (0, d.et)(e),
            { spanId: n } = e.spanContext(),
            a = (0, d.zU)(e) === e,
            o = `[Tracing] Finishing "${r}" ${a ? "root " : ""}span "${t}" with ID ${n}`;
          l.Yz.log(o);
        })(this),
        this._onSpanEnded());
    }
    getSpanJSON() {
      return {
        data: this._attributes,
        description: this._name,
        op: this._attributes[s.uT],
        parent_span_id: this._parentSpanId,
        span_id: this._spanId,
        start_timestamp: this._startTime,
        status: (0, d.yW)(this._status),
        timestamp: this._endTime,
        trace_id: this._traceId,
        origin: this._attributes[s.JD],
        profile_id: this._attributes[s.E1],
        exclusive_time: this._attributes[s.jG],
        measurements: y(this._events),
        is_segment: (this._isStandaloneSpan && (0, d.zU)(this) === this) || void 0,
        segment_id: this._isStandaloneSpan ? (0, d.zU)(this).spanContext().spanId : void 0,
        links: (0, d.uU)(this._links),
      };
    }
    isRecording() {
      return !this._endTime && !!this._sampled;
    }
    addEvent(e, t, r) {
      i.T && l.Yz.log("[Tracing] Adding an event to span:", e);
      let n = E(t) ? t : r || (0, p.zf)(),
        a = E(t) ? {} : t || {},
        o = { name: e, time: (0, d.cI)(n), attributes: a };
      return (this._events.push(o), this);
    }
    isStandaloneSpan() {
      return !!this._isStandaloneSpan;
    }
    _onSpanEnded() {
      let e = (0, o.KU)();
      if ((e && e.emit("spanEnd", this), !(this._isStandaloneSpan || this === (0, d.zU)(this))))
        return;
      if (this._isStandaloneSpan)
        return void (this._sampled
          ? (function (e) {
              let t = (0, o.KU)();
              if (!t) return;
              let r = e[1];
              if (!r || 0 === r.length) return t.recordDroppedEvent("before_send", "span");
              t.sendEnvelope(e);
            })((0, g.lu)([this], e))
          : (i.T &&
              l.Yz.log(
                "[Tracing] Discarding standalone span because its trace was not chosen to be sampled.",
              ),
            e && e.recordDroppedEvent("sample_rate", "span")));
      let t = this._convertSpanToTransaction();
      t && ((0, v.L)(this).scope || (0, o.o5)()).captureEvent(t);
    }
    _convertSpanToTransaction() {
      if (!R((0, d.et)(this))) return;
      this._name ||
        (i.T && l.Yz.warn("Transaction has no name, falling back to `<unlabeled transaction>`."),
        (this._name = "<unlabeled transaction>"));
      let { scope: e, isolationScope: t } = (0, v.L)(this),
        r = e?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
      if (!0 !== this._sampled) return;
      let n = (0, d.xO)(this)
          .filter((e) => {
            var t;
            return e !== this && !((t = e) instanceof b && t.isStandaloneSpan());
          })
          .map((e) => (0, d.et)(e))
          .filter(R),
        a = this._attributes[s.i_];
      (delete this._attributes[s.Le],
        n.forEach((e) => {
          delete e.data[s.Le];
        }));
      let o = {
          contexts: { trace: (0, d.Ck)(this) },
          spans:
            n.length > 1e3
              ? n.sort((e, t) => e.start_timestamp - t.start_timestamp).slice(0, 1e3)
              : n,
          start_timestamp: this._startTime,
          timestamp: this._endTime,
          transaction: this._name,
          type: "transaction",
          sdkProcessingMetadata: {
            capturedSpanScope: e,
            capturedSpanIsolationScope: t,
            dynamicSamplingContext: (0, h.k1)(this),
          },
          request: r,
          ...(a && { transaction_info: { source: a } }),
        },
        u = y(this._events);
      return (
        u &&
          Object.keys(u).length &&
          (i.T &&
            l.Yz.log(
              "[Measurements] Adding measurements to transaction event",
              JSON.stringify(u, void 0, 2),
            ),
          (o.measurements = u)),
        o
      );
    }
  }
  function E(e) {
    return (e && "number" == typeof e) || e instanceof Date || Array.isArray(e);
  }
  function R(e) {
    return !!e.start_timestamp && !!e.timestamp && !!e.span_id && !!e.trace_id;
  }
  var P = r(13590),
    S = r(76636),
    O = r(60057),
    T = r(40364);
  let w = "__SENTRY_SUPPRESS_TRACING__";
  function j(e) {
    let t = A();
    if (t.startInactiveSpan) return t.startInactiveSpan(e);
    let r = (function (e) {
        let t = { isStandalone: (e.experimental || {}).standalone, ...e };
        if (e.startTime) {
          let r = { ...t };
          return ((r.startTimestamp = (0, d.cI)(e.startTime)), delete r.startTime, r);
        }
        return t;
      })(e),
      { forceTransaction: n, parentSpan: a } = e;
    return (e.scope ? (t) => (0, o.v4)(e.scope, t) : void 0 !== a ? (e) => x(a, e) : (e) => e())(
      () => {
        let t = (0, o.o5)(),
          s = (function (e, t) {
            if (t) return t;
            if (null === t) return;
            let r = (0, f.f)(e);
            if (!r) return;
            let n = (0, o.KU)();
            return (n ? n.getOptions() : {}).parentSpanIsAlwaysRootSpan ? (0, d.zU)(r) : r;
          })(t, a);
        return e.onlyIfParent && !s
          ? new m()
          : (function ({ parentSpan: e, spanArguments: t, forceTransaction: r, scope: n }) {
              let a;
              if (!(0, u.f)()) {
                let n = new m();
                if (r || !e) {
                  let e = {
                    sampled: "false",
                    sample_rate: "0",
                    transaction: t.name,
                    ...(0, h.k1)(n),
                  };
                  (0, h.LZ)(n, e);
                }
                return n;
              }
              let s = (0, o.rm)();
              if (e && !r)
                ((a = (function (e, t, r) {
                  let { spanId: n, traceId: a } = e.spanContext(),
                    i = !t.getScopeData().sdkProcessingMetadata[w] && (0, d.pK)(e),
                    s = i
                      ? new b({ ...r, parentSpanId: n, traceId: a, sampled: i })
                      : new m({ traceId: a });
                  (0, d.Hu)(e, s);
                  let l = (0, o.KU)();
                  return (l && (l.emit("spanStart", s), r.endTimestamp && l.emit("spanEnd", s)), s);
                })(e, n, t)),
                  (0, d.Hu)(e, a));
              else if (e) {
                let r = (0, h.k1)(e),
                  { traceId: o, spanId: i } = e.spanContext(),
                  s = (0, d.pK)(e);
                ((a = C({ traceId: o, parentSpanId: i, ...t }, n, s)), (0, h.LZ)(a, r));
              } else {
                let {
                  traceId: e,
                  dsc: r,
                  parentSpanId: o,
                  sampled: i,
                } = { ...s.getPropagationContext(), ...n.getPropagationContext() };
                ((a = C({ traceId: e, parentSpanId: o, ...t }, n, i)), r && (0, h.LZ)(a, r));
              }
              return (
                !(function (e) {
                  if (!i.T) return;
                  let {
                      description: t = "< unknown name >",
                      op: r = "< unknown op >",
                      parent_span_id: n,
                    } = (0, d.et)(e),
                    { spanId: a } = e.spanContext(),
                    o = (0, d.pK)(e),
                    s = (0, d.zU)(e),
                    u = s === e,
                    c = `[Tracing] Starting ${o ? "sampled" : "unsampled"} ${u ? "root " : ""}span`,
                    f = [`op: ${r}`, `name: ${t}`, `ID: ${a}`];
                  if ((n && f.push(`parent ID: ${n}`), !u)) {
                    let { op: e, description: t } = (0, d.et)(s);
                    (f.push(`root ID: ${s.spanContext().spanId}`),
                      e && f.push(`root op: ${e}`),
                      t && f.push(`root description: ${t}`));
                  }
                  l.Yz.log(`${c}
  ${f.join("\n  ")}`);
                })(a),
                (0, v.d)(a, n, s),
                a
              );
            })({ parentSpan: s, spanArguments: r, forceTransaction: n, scope: t });
      },
    );
  }
  function x(e, t) {
    let r = A();
    return r.withActiveSpan
      ? r.withActiveSpan(e, t)
      : (0, o.v4)((r) => ((0, f.r)(r, e || void 0), t(r)));
  }
  function A() {
    let e = (0, O.EU)();
    return (0, S.h)(e);
  }
  function C(e, t, r) {
    let n = (0, o.KU)(),
      a = n?.getOptions() || {},
      { name: c = "" } = e,
      f = { spanAttributes: { ...e.attributes }, spanName: c, parentSampled: r };
    n?.emit("beforeSampling", f, { decision: !1 });
    let d = f.parentSampled ?? r,
      p = f.spanAttributes,
      h = t.getPropagationContext(),
      [_, m, g] = t.getScopeData().sdkProcessingMetadata[w]
        ? [!1]
        : (function (e, t, r) {
            let n, a;
            if (!(0, u.f)(e)) return [!1];
            "function" == typeof e.tracesSampler
              ? ((n = e.tracesSampler({
                  ...t,
                  inheritOrSampleWith: (e) =>
                    "number" == typeof t.parentSampleRate
                      ? t.parentSampleRate
                      : "boolean" == typeof t.parentSampled
                        ? Number(t.parentSampled)
                        : e,
                })),
                (a = !0))
              : void 0 !== t.parentSampled
                ? (n = t.parentSampled)
                : void 0 !== e.tracesSampleRate && ((n = e.tracesSampleRate), (a = !0));
            let o = (0, T.i)(n);
            if (void 0 === o)
              return (
                i.T &&
                  l.Yz.warn(
                    `[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(n)} of type ${JSON.stringify(typeof n)}.`,
                  ),
                [!1]
              );
            if (!o)
              return (
                i.T &&
                  l.Yz.log(
                    `[Tracing] Discarding transaction because ${"function" == typeof e.tracesSampler ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`,
                  ),
                [!1, o, a]
              );
            let s = r < o;
            return (
              !s &&
                i.T &&
                l.Yz.log(
                  `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(n)})`,
                ),
              [s, o, a]
            );
          })(
            a,
            {
              name: c,
              parentSampled: d,
              attributes: p,
              parentSampleRate: (0, T.i)(h.dsc?.sample_rate),
            },
            h.sampleRand,
          ),
      y = new b({
        ...e,
        attributes: { [s.i_]: "custom", [s.sy]: void 0 !== m && g ? m : void 0, ...p },
        sampled: _,
      });
    return (
      !_ &&
        n &&
        (i.T &&
          l.Yz.log(
            "[Tracing] Discarding root span because its trace was not chosen to be sampled.",
          ),
        n.recordDroppedEvent("sample_rate", "transaction")),
      n && n.emit("spanStart", y),
      y
    );
  }
  let M = { idleTimeout: 1e3, finalTimeout: 3e4, childSpanTimeout: 15e3 };
  function N(e, t = {}) {
    let r,
      n = new Map(),
      a = !1,
      _ = "externalFinish",
      g = !t.disableAutoFinish,
      y = [],
      {
        idleTimeout: v = M.idleTimeout,
        finalTimeout: E = M.finalTimeout,
        childSpanTimeout: R = M.childSpanTimeout,
        beforeSpanEnd: S,
        trimIdleSpanEndTimestamp: O = !0,
      } = t,
      T = (0, o.KU)();
    if (!T || !(0, u.f)()) {
      let e = new m(),
        t = { sample_rate: "0", sampled: "false", ...(0, h.k1)(e) };
      return ((0, h.LZ)(e, t), e);
    }
    let w = (0, o.o5)(),
      x = (0, d.Bk)(),
      A = (function (e) {
        let t = j(e);
        return (
          (0, f.r)((0, o.o5)(), t),
          i.T && l.Yz.log("[Tracing] Started span is an idle span"),
          t
        );
      })(e);
    function C() {
      r && (clearTimeout(r), (r = void 0));
    }
    function k(e) {
      (C(),
        (r = setTimeout(() => {
          !a && 0 === n.size && g && ((_ = "idleTimeout"), A.end(e));
        }, v)));
    }
    function I(e) {
      r = setTimeout(() => {
        !a && g && ((_ = "heartbeatFailed"), A.end(e));
      }, R);
    }
    function L(e) {
      ((a = !0), n.clear(), y.forEach((e) => e()), (0, f.r)(w, x));
      let t = (0, d.et)(A),
        { start_timestamp: r } = t;
      if (!r) return;
      t.data[s.fs] || A.setAttribute(s.fs, _);
      let o = t.status;
      ((o && "unknown" !== o) || A.setStatus({ code: P.F3 }),
        l.Yz.log(`[Tracing] Idle span "${t.op}" finished`));
      let u = (0, d.xO)(A).filter((e) => e !== A),
        c = 0;
      (u.forEach((t) => {
        t.isRecording() &&
          (t.setStatus({ code: P.TJ, message: "cancelled" }),
          t.end(e),
          i.T &&
            l.Yz.log(
              "[Tracing] Cancelling span since span ended early",
              JSON.stringify(t, void 0, 2),
            ));
        let { timestamp: r = 0, start_timestamp: n = 0 } = (0, d.et)(t),
          a = n <= e,
          o = r - n <= (E + v) / 1e3;
        if (i.T) {
          let e = JSON.stringify(t, void 0, 2);
          a
            ? o ||
              l.Yz.log(
                "[Tracing] Discarding span since it finished after idle span final timeout",
                e,
              )
            : l.Yz.log(
                "[Tracing] Discarding span since it happened after idle span was finished",
                e,
              );
        }
        (!o || !a) && ((0, d.VS)(A, t), c++);
      }),
        c > 0 && A.setAttribute("sentry.idle_span_discarded_spans", c));
    }
    return (
      (A.end = new Proxy(A.end, {
        apply(e, t, r) {
          if ((S && S(A), t instanceof m)) return;
          let [n, ...a] = r,
            o = n || (0, p.zf)(),
            i = (0, d.cI)(o),
            s = (0, d.xO)(A).filter((e) => e !== A),
            l = (0, d.et)(A);
          if (!s.length || !O) return (L(i), Reflect.apply(e, t, [i, ...a]));
          let u = T.getOptions().ignoreSpans,
            f = s?.reduce(
              (e, t) => {
                let r = (0, d.et)(t);
                return !r.timestamp || (u && (0, c.e)(r, u))
                  ? e
                  : e
                    ? Math.max(e, r.timestamp)
                    : r.timestamp;
              },
              void 0,
            ),
            h = l.start_timestamp,
            _ = Math.min(h ? h + E / 1e3 : 1 / 0, Math.max(h || -1 / 0, Math.min(i, f || 1 / 0)));
          return (L(_), Reflect.apply(e, t, [_, ...a]));
        },
      })),
      y.push(
        T.on("spanStart", (e) => {
          var t;
          !(a || e === A || (0, d.et)(e).timestamp || (e instanceof b && e.isStandaloneSpan())) &&
            (0, d.xO)(A).includes(e) &&
            ((t = e.spanContext().spanId), C(), n.set(t, !0), I((0, p.zf)() + R / 1e3));
        }),
      ),
      y.push(
        T.on("spanEnd", (e) => {
          if (!a) {
            var t;
            ((t = e.spanContext().spanId),
              n.has(t) && n.delete(t),
              0 === n.size && k((0, p.zf)() + v / 1e3));
          }
        }),
      ),
      y.push(
        T.on("idleSpanEnableAutoFinish", (e) => {
          e === A && ((g = !0), k(), n.size && I());
        }),
      ),
      t.disableAutoFinish || k(),
      setTimeout(() => {
        a ||
          (A.setStatus({ code: P.TJ, message: "deadline_exceeded" }),
          (_ = "finalTimeout"),
          A.end());
      }, E),
      A
    );
  }
  var k = r(54402),
    I = r(20370);
  let L = !1;
  var D = r(49636),
    U = r(64189),
    H = r(60567),
    F = r(69142),
    $ = r(73314),
    B = r(35868),
    z = r(16649),
    q = r(38599),
    Y = r(96812),
    X = r(75784),
    W = r(36825);
  function K(e) {
    return "number" == typeof e && isFinite(e);
  }
  function G(e, t, r, { ...n }) {
    let a = (0, d.et)(e).start_timestamp;
    return (
      a && a > t && "function" == typeof e.updateStartTime && e.updateStartTime(t),
      x(e, () => {
        let e = j({ startTime: t, ...n });
        return (e && e.end(r), e);
      })
    );
  }
  function V(e) {
    let t,
      r = (0, o.KU)();
    if (!r) return;
    let { name: n, transaction: a, attributes: i, startTime: s } = e,
      { release: l, environment: u, sendDefaultPii: c } = r.getOptions(),
      f = r.getIntegrationByName("Replay"),
      d = f?.getReplayId(),
      p = (0, o.o5)(),
      h = p.getUser(),
      _ = void 0 !== h ? h.email || h.id || h.ip_address : void 0;
    try {
      t = p.getScopeData().contexts.profile.profile_id;
    } catch {}
    return j({
      name: n,
      attributes: {
        release: l,
        environment: u,
        user: _ || void 0,
        profile_id: t || void 0,
        replay_id: d || void 0,
        transaction: a,
        "user_agent.original": q.j.navigator?.userAgent,
        "client.address": c ? "{{auto}}" : void 0,
        ...i,
      },
      startTime: s,
      experimental: { standalone: !0 },
    });
  }
  function J() {
    return q.j.addEventListener && q.j.performance;
  }
  function Q(e) {
    return e / 1e3;
  }
  function Z(e) {
    try {
      return PerformanceObserver.supportedEntryTypes.includes(e);
    } catch {
      return !1;
    }
  }
  function ee(e, t) {
    let r,
      n = !1;
    function a(e) {
      (!n && r && t(e, r), (n = !0));
    }
    let o = (e) => {
      ("pagehide" === e.type || q.j.document?.visibilityState === "hidden") && a("pagehide");
    };
    ((0, W.d)("visibilitychange", o, { capture: !0, once: !0 }),
      (0, W.d)("pagehide", o, { capture: !0, once: !0 }));
    let i = e.on("beforeStartNavigationSpan", (e, t) => {
        t?.isRedirect || (a("navigation"), i(), s());
      }),
      s = e.on("afterStartPageLoadSpan", (e) => {
        ((r = e.spanContext().spanId), s());
      });
  }
  function et(e) {
    return e ? (((0, p.k3)() || performance.timeOrigin) + e) / 1e3 : e;
  }
  function er(e) {
    let t = {};
    if (void 0 != e.nextHopProtocol) {
      let { name: r, version: n } = (function (e) {
        let t = "unknown",
          r = "unknown",
          n = "";
        for (let a of e) {
          if ("/" === a) {
            [t, r] = e.split("/");
            break;
          }
          if (!isNaN(Number(a))) {
            ((t = "h" === n ? "http" : n), (r = e.split(n)[1]));
            break;
          }
          n += a;
        }
        return (n === e && (t = n), { name: t, version: r });
      })(e.nextHopProtocol);
      ((t["network.protocol.version"] = n), (t["network.protocol.name"] = r));
    }
    return (0, p.k3)() || J()?.timeOrigin
      ? Object.fromEntries(
          Object.entries({
            ...t,
            "http.request.redirect_start": et(e.redirectStart),
            "http.request.redirect_end": et(e.redirectEnd),
            "http.request.worker_start": et(e.workerStart),
            "http.request.fetch_start": et(e.fetchStart),
            "http.request.domain_lookup_start": et(e.domainLookupStart),
            "http.request.domain_lookup_end": et(e.domainLookupEnd),
            "http.request.connect_start": et(e.connectStart),
            "http.request.secure_connection_start": et(e.secureConnectionStart),
            "http.request.connection_end": et(e.connectEnd),
            "http.request.request_start": et(e.requestStart),
            "http.request.response_start": et(e.responseStart),
            "http.request.response_end": et(e.responseEnd),
            "http.request.time_to_first_byte":
              null != e.responseStart ? e.responseStart / 1e3 : void 0,
          }).filter(([, e]) => null != e),
        )
      : t;
  }
  var en = r(32191),
    ea = r(23989),
    eo = r(14231);
  let ei = 0,
    es = {};
  function el(e, t, r, n, a = r) {
    var o;
    let i =
        t[
          "secureConnection" === (o = r)
            ? "connectEnd"
            : "fetch" === o
              ? "domainLookupStart"
              : `${o}End`
        ],
      l = t[`${r}Start`];
    l &&
      i &&
      G(e, n + Q(l), n + Q(i), {
        op: `browser.${a}`,
        name: t.name,
        attributes: {
          [s.JD]: "auto.ui.browser.metrics",
          ...("redirect" === r && null != t.redirectCount
            ? { "http.redirect_count": t.redirectCount }
            : {}),
        },
      });
  }
  var eu = r(97684);
  let ec = [],
    ef = new Map(),
    ed = new Map(),
    ep = {
      click: "click",
      pointerdown: "click",
      pointerup: "click",
      mousedown: "click",
      mouseup: "click",
      touchstart: "click",
      touchend: "click",
      mouseover: "hover",
      mouseout: "hover",
      mouseenter: "hover",
      mouseleave: "hover",
      pointerover: "hover",
      pointerout: "hover",
      pointerenter: "hover",
      pointerleave: "hover",
      dragstart: "drag",
      dragend: "drag",
      drag: "drag",
      dragenter: "drag",
      dragleave: "drag",
      dragover: "drag",
      drop: "drag",
      keydown: "press",
      keyup: "press",
      keypress: "press",
      input: "press",
    },
    eh = ({ metric: e }) => {
      if (void 0 == e.value) return;
      let t = Q(e.value);
      if (t > 60) return;
      let r = e.entries.find((t) => t.duration === e.value && ep[t.name]);
      if (!r) return;
      let { interactionId: n } = r,
        a = ep[r.name],
        i = Q((0, p.k3)() + r.startTime),
        l = (0, d.Bk)(),
        u = l ? (0, d.zU)(l) : void 0,
        c = null != n ? ef.get(n) : void 0,
        f = c?.span || u,
        h = f ? (0, d.et)(f).description : (0, o.o5)().getScopeData().transactionName,
        _ = V({
          name: c?.elementName || (0, H.Hd)(r.target),
          transaction: h,
          attributes: {
            [s.JD]: "auto.http.browser.inp",
            [s.uT]: `ui.interaction.${a}`,
            [s.jG]: r.duration,
          },
          startTime: i,
        });
      _ && (_.addEvent("inp", { [s.Sn]: "millisecond", [s.xc]: e.value }), _.end(i + t));
    };
  var e_ = r(79152),
    em = r(91488),
    eg = r(39619);
  let ey = "sentry_previous_trace";
  function ev(e) {
    return 1 === e.traceFlags;
  }
  var eb = r(81725),
    eE = r(30249),
    eR = r(27122);
  function eP(e = {}) {
    let t = e.client || (0, o.KU)();
    if (!(0, eR.Ol)() || !t) return {};
    let r = (0, O.EU)(),
      n = (0, S.h)(r);
    if (n.getTraceData) return n.getTraceData(e);
    let a = e.scope || (0, o.o5)(),
      i = e.span || (0, d.Bk)();
    if (!i && (0, o.Bi)()) return {};
    let s = i
        ? (0, d.Qh)(i)
        : (function (e) {
            let { traceId: t, sampled: r, propagationSpanId: n } = e.getPropagationContext();
            return (0, U.TC)(t, n, r);
          })(a),
      u = i ? (0, h.k1)(i) : (0, h.ao)(t, a),
      c = (0, eE.De)(u);
    if (!U.MI.test(s))
      return (l.Yz.warn("Invalid sentry-trace data. Cannot generate trace data"), {});
    let f = { "sentry-trace": s, baggage: c };
    return (
      e.propagateTraceparent &&
        (f.traceparent = i
          ? (0, d.G_)(i)
          : (function (e) {
              let { traceId: t, sampled: r, propagationSpanId: n } = e.getPropagationContext();
              return (0, U.Iy)(t, n, r);
            })(a)),
      f
    );
  }
  function eS(e) {
    return e.split(",").some((e) => e.trim().startsWith(eE.sv));
  }
  function eO(e, t, r, n) {
    let a = {
      url: (0, F.zm)(e),
      type: "fetch",
      "http.method": r,
      [s.JD]: n,
      [s.uT]: "http.client",
    };
    return (
      t &&
        ((0, F.nt)(t) || ((a["http.url"] = (0, F.zm)(t.href)), (a["server.address"] = t.host)),
        t.search && (a["http.query"] = t.search),
        t.hash && (a["http.fragment"] = t.hash)),
      a
    );
  }
  var eT = r(62234),
    ew = r(97309);
  function ej(e) {
    try {
      return new URL(e, eg.jf.location.origin).href;
    } catch {
      return;
    }
  }
  function ex(e) {
    try {
      return new Headers(e);
    } catch {
      return;
    }
  }
  let eA = new WeakMap(),
    eC = new Map(),
    eM = { traceFetch: !0, traceXHR: !0, enableHTTPTimings: !0, trackFetchStreamPerformance: !1 };
  function eN(e) {
    let { url: t } = (0, d.et)(e).data;
    if (!t || "string" != typeof t) return;
    let r = (0, X.wv)("resource", ({ entries: n }) => {
      n.forEach((n) => {
        "resource" === n.entryType &&
          "initiatorType" in n &&
          "string" == typeof n.nextHopProtocol &&
          ("fetch" === n.initiatorType || "xmlhttprequest" === n.initiatorType) &&
          n.name.endsWith(t) &&
          (e.setAttributes(er(n)), setTimeout(r));
      });
    });
  }
  let ek =
      /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i,
    eI = {
      ...M,
      instrumentNavigation: !0,
      instrumentPageLoad: !0,
      markBackgroundSpan: !0,
      enableLongTask: !0,
      enableLongAnimationFrame: !0,
      enableInp: !0,
      ignoreResourceSpans: [],
      ignorePerformanceApiSpans: [],
      detectRedirects: !0,
      linkPreviousTrace: "in-memory",
      consistentTraceSampling: !1,
      enableReportPageLoaded: !1,
      _experiments: {},
      ...eM,
    },
    eL = (e = {}) => {
      let t, r, c;
      "enableElementTiming" in e &&
        (0, l.pq)(() => {
          console.warn(
            "[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.",
          );
        });
      let f = { name: void 0, source: void 0 },
        g = eg.jf.document,
        {
          enableInp: y,
          enableLongTask: v,
          enableLongAnimationFrame: b,
          _experiments: {
            enableInteractions: E,
            enableStandaloneClsSpans: R,
            enableStandaloneLcpSpans: S,
          },
          beforeStartSpan: O,
          idleTimeout: T,
          finalTimeout: w,
          childSpanTimeout: x,
          markBackgroundSpan: A,
          traceFetch: C,
          traceXHR: M,
          trackFetchStreamPerformance: W,
          shouldCreateSpanForRequest: et,
          enableHTTPTimings: eE,
          ignoreResourceSpans: eR,
          ignorePerformanceApiSpans: eL,
          instrumentPageLoad: eB,
          instrumentNavigation: ez,
          detectRedirects: eq,
          linkPreviousTrace: eY,
          consistentTraceSampling: eX,
          enableReportPageLoaded: eW,
          onRequestSpanStart: eK,
          onRequestSpanEnd: eG,
        } = { ...eI, ...e },
        eV = (function () {
          let e = eg.jf.navigator;
          return !!e?.userAgent && ek.test(e.userAgent);
        })();
      function eJ(e, r, u = !0) {
        var _, m;
        let y = "pageload" === r.op,
          v = r.name,
          b = O ? O(r) : r,
          E = b.attributes || {};
        if ((v !== b.name && ((E[s.i_] = "custom"), (b.attributes = E)), !u)) {
          let e = (0, p.lu)();
          j({ ...b, startTime: e }).end(e);
          return;
        }
        ((f.name = b.name), (f.source = E[s.i_]));
        let P = N(b, {
          idleTimeout: T,
          finalTimeout: w,
          childSpanTimeout: x,
          disableAutoFinish: y,
          beforeSpanEnd: (r) => {
            var u, f;
            (t?.(),
              (function (e, t) {
                var r, o;
                let u = J(),
                  c = (0, p.k3)();
                if (!u?.getEntries || !c) return;
                let f = Q(c),
                  h = u.getEntries(),
                  { op: _, start_timestamp: m } = (0, d.et)(e);
                (h.slice(ei).forEach((r) => {
                  let n = Q(r.startTime),
                    a = Q(Math.max(0, r.duration));
                  if ("navigation" !== _ || !m || !(f + n < m))
                    switch (r.entryType) {
                      case "navigation":
                        var o, i, l;
                        ((o = e),
                          (i = r),
                          (l = f),
                          [
                            "unloadEvent",
                            "redirect",
                            "domContentLoadedEvent",
                            "loadEvent",
                            "connect",
                          ].forEach((e) => {
                            el(o, i, e, l);
                          }),
                          el(o, i, "secureConnection", l, "TLS/SSL"),
                          el(o, i, "fetch", l, "cache"),
                          el(o, i, "domainLookup", l, "DNS"),
                          (function (e, t, r) {
                            let n = r + Q(t.requestStart),
                              a = r + Q(t.responseEnd),
                              o = r + Q(t.responseStart);
                            t.responseEnd &&
                              (G(e, n, a, {
                                op: "browser.request",
                                name: t.name,
                                attributes: { [s.JD]: "auto.ui.browser.metrics" },
                              }),
                              G(e, o, a, {
                                op: "browser.response",
                                name: t.name,
                                attributes: { [s.JD]: "auto.ui.browser.metrics" },
                              }));
                          })(o, i, l));
                        break;
                      case "mark":
                      case "paint":
                      case "measure": {
                        !(function (e, t, r, n, a, o) {
                          if (
                            (function (e) {
                              if (e?.entryType === "measure")
                                try {
                                  return "Components ⚛" === e.detail.devtools.track;
                                } catch {
                                  return;
                                }
                            })(t) ||
                            (["mark", "measure"].includes(t.entryType) && (0, B.Xr)(t.name, o))
                          )
                            return;
                          let i = (0, ea.z)(!1),
                            l = a + Math.max(r, Q(i ? i.requestStart : 0)),
                            u = a + r,
                            c = u + n,
                            f = { [s.JD]: "auto.resource.browser.metrics" };
                          (l !== u &&
                            ((f["sentry.browser.measure_happened_before_request"] = !0),
                            (f["sentry.browser.measure_start_time"] = l)),
                            (function (e, t) {
                              try {
                                let r = t.detail;
                                if (!r) return;
                                if ("object" == typeof r) {
                                  for (let [t, n] of Object.entries(r))
                                    if (n && (0, z.sO)(n))
                                      e[`sentry.browser.measure.detail.${t}`] = n;
                                    else if (void 0 !== n)
                                      try {
                                        e[`sentry.browser.measure.detail.${t}`] = JSON.stringify(n);
                                      } catch {}
                                  return;
                                }
                                if ((0, z.sO)(r)) {
                                  e["sentry.browser.measure.detail"] = r;
                                  return;
                                }
                                try {
                                  e["sentry.browser.measure.detail"] = JSON.stringify(r);
                                } catch {}
                              } catch {}
                            })(f, t),
                            l <= c && G(e, l, c, { name: t.name, op: t.entryType, attributes: f }));
                        })(e, r, n, a, f, t.ignorePerformanceApiSpans);
                        let o = (0, eo.N)(),
                          i = r.startTime < o.firstHiddenTime;
                        ("first-paint" === r.name &&
                          i &&
                          (es.fp = { value: r.startTime, unit: "millisecond" }),
                          "first-contentful-paint" === r.name &&
                            i &&
                            (es.fcp = { value: r.startTime, unit: "millisecond" }));
                        break;
                      }
                      case "resource":
                        !(function (e, t, r, n, a, o, i) {
                          var l, u;
                          if ("xmlhttprequest" === t.initiatorType || "fetch" === t.initiatorType)
                            return;
                          let c = t.initiatorType
                            ? `resource.${t.initiatorType}`
                            : "resource.other";
                          if (i?.includes(c)) return;
                          let f = { [s.JD]: "auto.resource.browser.metrics" },
                            d = (0, F.Dl)(r);
                          (d.protocol && (f["url.scheme"] = d.protocol.split(":").pop()),
                            d.host && (f["server.address"] = d.host),
                            (f["url.same_origin"] = r.includes(q.j.location.origin)),
                            (l = t),
                            (u = f),
                            [
                              ["responseStatus", "http.response.status_code"],
                              ["transferSize", "http.response_transfer_size"],
                              ["encodedBodySize", "http.response_content_length"],
                              ["decodedBodySize", "http.decoded_response_content_length"],
                              ["renderBlockingStatus", "resource.render_blocking_status"],
                              ["deliveryType", "http.response_delivery_type"],
                            ].forEach(([e, t]) => {
                              let r = l[e];
                              null != r &&
                                (("number" == typeof r && r < 0x7fffffff) ||
                                  "string" == typeof r) &&
                                (u[t] = r);
                            }));
                          let p = { ...f, ...er(t) },
                            h = o + n;
                          G(e, h, h + a, {
                            name: r.replace(q.j.location.origin, ""),
                            op: c,
                            attributes: p,
                          });
                        })(e, r, r.name, n, a, f, t.ignoreResourceSpans);
                    }
                }),
                  (ei = Math.max(h.length - 1, 0)),
                  (function (e) {
                    let t = q.j.navigator;
                    if (!t) return;
                    let r = t.connection;
                    (r &&
                      (r.effectiveType &&
                        e.setAttribute("effectiveConnectionType", r.effectiveType),
                      r.type && e.setAttribute("connectionType", r.type),
                      K(r.rtt) && (es["connection.rtt"] = { value: r.rtt, unit: "millisecond" })),
                      K(t.deviceMemory) && e.setAttribute("deviceMemory", `${t.deviceMemory} GB`),
                      K(t.hardwareConcurrency) &&
                        e.setAttribute("hardwareConcurrency", String(t.hardwareConcurrency)));
                  })(e),
                  "pageload" === _ &&
                    ((function (e) {
                      let t = (0, ea.z)(!1);
                      if (!t) return;
                      let { responseStart: r, requestStart: n } = t;
                      n <= r && (e["ttfb.requestTime"] = { value: r - n, unit: "millisecond" });
                    })(es),
                    t.recordClsOnPageloadSpan || delete es.cls,
                    t.recordLcpOnPageloadSpan || delete es.lcp,
                    Object.entries(es).forEach(([e, t]) => {
                      !(function (e, t, r, n = (0, d.Bk)()) {
                        let a = n && (0, d.zU)(n);
                        a &&
                          (i.T &&
                            l.Yz.log(
                              `[Measurement] Setting measurement on root span: ${e} = ${t} ${r}`,
                            ),
                          a.addEvent(e, { [s.xc]: t, [s.Sn]: r }));
                      })(e, t.value, t.unit);
                    }),
                    e.setAttribute("performance.timeOrigin", f),
                    e.setAttribute("performance.activationStart", (0, en.b)()),
                    (r = e),
                    (o = t),
                    n &&
                      o.recordLcpOnPageloadSpan &&
                      (n.element && r.setAttribute("lcp.element", (0, H.Hd)(n.element)),
                      n.id && r.setAttribute("lcp.id", n.id),
                      n.url && r.setAttribute("lcp.url", n.url.trim().slice(0, 200)),
                      null != n.loadTime && r.setAttribute("lcp.loadTime", n.loadTime),
                      null != n.renderTime && r.setAttribute("lcp.renderTime", n.renderTime),
                      r.setAttribute("lcp.size", n.size)),
                    a?.sources &&
                      o.recordClsOnPageloadSpan &&
                      a.sources.forEach((e, t) =>
                        r.setAttribute(`cls.source.${t + 1}`, (0, H.Hd)(e.node)),
                      )),
                  (n = void 0),
                  (a = void 0),
                  (es = {}));
              })(r, {
                recordClsOnPageloadSpan: !R,
                recordLcpOnPageloadSpan: !S,
                ignoreResourceSpans: eR,
                ignorePerformanceApiSpans: eL,
              }),
              (u = e),
              (f = void 0),
              (0, $.my)(u, e$, f));
            let _ = (0, o.o5)(),
              m = _.getPropagationContext();
            (_.setPropagationContext({
              ...m,
              traceId: P.spanContext().traceId,
              sampled: (0, d.pK)(P),
              dsc: (0, h.k1)(r),
            }),
              y && (c = void 0));
          },
          trimIdleSpanEndTimestamp: !eW,
        });
        function A() {
          g &&
            ["interactive", "complete"].includes(g.readyState) &&
            e.emit("idleSpanEnableAutoFinish", P);
        }
        (y && eW && (c = P),
          (_ = e),
          (m = P),
          (0, $.my)(_, e$, m),
          y &&
            !eW &&
            g &&
            (g.addEventListener("readystatechange", () => {
              A();
            }),
            A()));
      }
      return {
        name: "BrowserTracing",
        setup(e) {
          if (eV) {
            em.T &&
              l.Yz.log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
            return;
          }
          function f() {
            let e = (0, d.Bk)(),
              t = e && (0, d.zU)(e);
            if (t) {
              let e = "internal_error";
              (i.T && l.Yz.log(`[Tracing] Root span: ${e} -> Global error occurred`),
                t.setStatus({ code: P.TJ, message: e }));
            }
          }
          if (
            (L || ((f.tag = "sentry_tracingErrorCallback"), (L = !0), (0, k.L)(f), (0, I.r)(f)),
            (t = (function ({
              recordClsStandaloneSpans: e,
              recordLcpStandaloneSpans: t,
              client: r,
            }) {
              let i = J();
              if (i && (0, p.k3)()) {
                i.mark && q.j.performance.mark("sentry-tracing-init");
                let u = t
                    ? (function (e) {
                        let t,
                          r = 0;
                        if (!Z("largest-contentful-paint")) return;
                        let n = (0, X.Pt)(({ metric: e }) => {
                          let n = e.entries[e.entries.length - 1];
                          n && ((r = e.value), (t = n));
                        }, !0);
                        ee(e, (e, a) => {
                          ((function (e, t, r, n) {
                            Y.T && l.Yz.log(`Sending LCP span (${e})`);
                            let a = Q(((0, p.k3)() || 0) + (t?.startTime || 0)),
                              i = (0, o.o5)().getScopeData().transactionName,
                              u = t ? (0, H.Hd)(t.element) : "Largest contentful paint",
                              c = {
                                [s.JD]: "auto.http.browser.lcp",
                                [s.uT]: "ui.webvital.lcp",
                                [s.jG]: 0,
                                "sentry.pageload.span_id": r,
                                "sentry.report_event": n,
                              };
                            t &&
                              (t.element && (c["lcp.element"] = (0, H.Hd)(t.element)),
                              t.id && (c["lcp.id"] = t.id),
                              t.url && (c["lcp.url"] = t.url),
                              null != t.loadTime && (c["lcp.loadTime"] = t.loadTime),
                              null != t.renderTime && (c["lcp.renderTime"] = t.renderTime),
                              null != t.size && (c["lcp.size"] = t.size));
                            let f = V({ name: u, transaction: i, attributes: c, startTime: a });
                            f &&
                              (f.addEvent("lcp", { [s.Sn]: "millisecond", [s.xc]: e }), f.end(a));
                          })(r, t, a, e),
                            n());
                        });
                      })(r)
                    : (0, X.Pt)(({ metric: e }) => {
                        let t = e.entries[e.entries.length - 1];
                        t && ((es.lcp = { value: e.value, unit: "millisecond" }), (n = t));
                      }, !0),
                  c = (0, X.YG)(({ metric: e }) => {
                    e.entries[e.entries.length - 1] &&
                      (es.ttfb = { value: e.value, unit: "millisecond" });
                  }),
                  f = e
                    ? (function (e) {
                        let t,
                          r = 0;
                        if (!Z("layout-shift")) return;
                        let n = (0, X.a9)(({ metric: e }) => {
                          let n = e.entries[e.entries.length - 1];
                          n && ((r = e.value), (t = n));
                        }, !0);
                        ee(e, (e, a) => {
                          ((function (e, t, r, n) {
                            Y.T && l.Yz.log(`Sending CLS span (${e})`);
                            let a = t ? Q(((0, p.k3)() || 0) + t.startTime) : (0, p.zf)(),
                              i = (0, o.o5)().getScopeData().transactionName,
                              u = t ? (0, H.Hd)(t.sources[0]?.node) : "Layout shift",
                              c = {
                                [s.JD]: "auto.http.browser.cls",
                                [s.uT]: "ui.webvital.cls",
                                [s.jG]: 0,
                                "sentry.pageload.span_id": r,
                                "sentry.report_event": n,
                              };
                            t?.sources &&
                              t.sources.forEach((e, t) => {
                                c[`cls.source.${t + 1}`] = (0, H.Hd)(e.node);
                              });
                            let f = V({ name: u, transaction: i, attributes: c, startTime: a });
                            f && (f.addEvent("cls", { [s.Sn]: "", [s.xc]: e }), f.end(a));
                          })(r, t, a, e),
                            n());
                        });
                      })(r)
                    : (0, X.a9)(({ metric: e }) => {
                        let t = e.entries[e.entries.length - 1];
                        t && ((es.cls = { value: e.value, unit: "" }), (a = t));
                      }, !0);
                return () => {
                  (u?.(), c(), f?.());
                };
              }
              return () => void 0;
            })({
              recordClsStandaloneSpans: R || !1,
              recordLcpStandaloneSpans: S || !1,
              client: e,
            })),
            y &&
              (function () {
                if (J() && (0, p.k3)()) {
                  let e = (0, X.hT)(eh);
                  () => {
                    e();
                  };
                }
              })(),
            b &&
            D.O.PerformanceObserver &&
            PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")
              ? new PerformanceObserver((e) => {
                  let t = (0, d.Bk)();
                  if (t)
                    for (let r of e.getEntries()) {
                      if (!r.scripts[0]) continue;
                      let e = Q((0, p.k3)() + r.startTime),
                        { start_timestamp: n, op: a } = (0, d.et)(t);
                      if ("navigation" === a && n && e < n) continue;
                      let o = Q(r.duration),
                        i = { [s.JD]: "auto.ui.browser.metrics" },
                        {
                          invoker: l,
                          invokerType: u,
                          sourceURL: c,
                          sourceFunctionName: f,
                          sourceCharPosition: h,
                        } = r.scripts[0];
                      ((i["browser.script.invoker"] = l),
                        (i["browser.script.invoker_type"] = u),
                        c && (i["code.filepath"] = c),
                        f && (i["code.function"] = f),
                        -1 !== h && (i["browser.script.source_char_position"] = h),
                        G(t, e, e + o, {
                          name: "Main UI thread blocked",
                          op: "ui.long-animation-frame",
                          attributes: i,
                        }));
                    }
                }).observe({ type: "long-animation-frame", buffered: !0 })
              : v &&
                (0, X.wv)("longtask", ({ entries: e }) => {
                  let t = (0, d.Bk)();
                  if (!t) return;
                  let { op: r, start_timestamp: n } = (0, d.et)(t);
                  for (let a of e) {
                    let e = Q((0, p.k3)() + a.startTime),
                      o = Q(a.duration);
                    ("navigation" === r && n && e < n) ||
                      G(t, e, e + o, {
                        name: "Main UI thread blocked",
                        op: "ui.long-task",
                        attributes: { [s.JD]: "auto.ui.browser.metrics" },
                      });
                  }
                }),
            E &&
              (0, X.wv)("event", ({ entries: e }) => {
                let t = (0, d.Bk)();
                if (t) {
                  for (let r of e)
                    if ("click" === r.name) {
                      let e = Q((0, p.k3)() + r.startTime),
                        n = Q(r.duration),
                        a = {
                          name: (0, H.Hd)(r.target),
                          op: `ui.interaction.${r.name}`,
                          startTime: e,
                          attributes: { [s.JD]: "auto.ui.browser.metrics" },
                        },
                        o = (0, H.xE)(r.target);
                      (o && (a.attributes["ui.component_name"] = o), G(t, e, e + n, a));
                    }
                }
              }),
            eq && g)
          ) {
            let e = () => {
              r = (0, p.zf)();
            };
            (addEventListener("click", e, { capture: !0 }),
              addEventListener("keydown", e, { capture: !0, passive: !0 }));
          }
          function h() {
            let t = e[e$];
            t &&
              !(0, d.et)(t).timestamp &&
              (em.T &&
                l.Yz.log(`[Tracing] Finishing current active span with op: ${(0, d.et)(t).op}`),
              t.setAttribute(s.fs, "cancelled"),
              t.end());
          }
          (e.on("startNavigationSpan", (t, n) => {
            if ((0, o.KU)() !== e) return;
            if (n?.isRedirect) {
              (em.T &&
                l.Yz.warn(
                  "[Tracing] Detected redirect, navigation span will not be the root span, but a child span.",
                ),
                eJ(e, { op: "navigation.redirect", ...t }, !1));
              return;
            }
            ((r = void 0),
              h(),
              (0, o.rm)().setPropagationContext({
                traceId: (0, _.e)(),
                sampleRand: Math.random(),
                propagationSpanId: (0, u.f)() ? void 0 : (0, _.Z)(),
              }));
            let a = (0, o.o5)();
            (a.setPropagationContext({
              traceId: (0, _.e)(),
              sampleRand: Math.random(),
              propagationSpanId: (0, u.f)() ? void 0 : (0, _.Z)(),
            }),
              a.setSDKProcessingMetadata({ normalizedRequest: void 0 }),
              eJ(e, { op: "navigation", ...t, parentSpan: null, forceTransaction: !0 }));
          }),
            e.on("startPageLoadSpan", (t, r = {}) => {
              if ((0, o.KU)() !== e) return;
              h();
              let n = r.sentryTrace || eH("sentry-trace") || eF("sentry-trace"),
                a = r.baggage || eH("baggage") || eF("baggage"),
                i = (0, U.kM)(n, a),
                s = (0, o.o5)();
              (s.setPropagationContext(i),
                (0, u.f)() || (s.getPropagationContext().propagationSpanId = (0, _.Z)()),
                s.setSDKProcessingMetadata({ normalizedRequest: (0, eg.AP)() }),
                eJ(e, { op: "pageload", ...t }));
            }),
            e.on("endPageloadSpan", () => {
              eW && c && (c.setAttribute(s.fs, "reportPageLoaded"), c.end());
            }));
        },
        afterAllSetup(e) {
          var t, n, a, i, c;
          let h;
          if (eV) return;
          let _ = (0, H.$N)();
          if (
            ("off" !== eY &&
              (function (e, { linkPreviousTrace: t, consistentTraceSampling: r }) {
                let n = "session-storage" === t,
                  a = n
                    ? (function () {
                        try {
                          let e = eg.jf.sessionStorage?.getItem(ey);
                          return JSON.parse(e);
                        } catch {
                          return;
                        }
                      })()
                    : void 0;
                e.on("spanStart", (e) => {
                  if ((0, d.zU)(e) !== e) return;
                  let t = (0, o.o5)().getPropagationContext();
                  ((a = (function (e, t, r) {
                    let n = (0, d.et)(t),
                      a = {
                        spanContext: t.spanContext(),
                        startTimestamp: n.start_timestamp,
                        sampleRate: (function () {
                          try {
                            return Number(r.dsc?.sample_rate) ?? Number(n.data?.[s.sy]);
                          } catch {
                            return 0;
                          }
                        })(),
                        sampleRand: r.sampleRand,
                      };
                    if (!e) return a;
                    let o = e.spanContext;
                    return o.traceId === n.trace_id
                      ? e
                      : (Date.now() / 1e3 - e.startTimestamp <= 3600 &&
                          (em.T &&
                            l.Yz.log(
                              `Adding previous_trace \`${JSON.stringify(o)}\` link to span \`${JSON.stringify({ op: n.op, ...t.spanContext() })}\``,
                            ),
                          t.addLink({ context: o, attributes: { [s.Lc]: "previous_trace" } }),
                          t.setAttribute(
                            "sentry.previous_trace",
                            `${o.traceId}-${o.spanId}-${+!!ev(o)}`,
                          )),
                        a);
                  })(a, e, t)),
                    n &&
                      (function (e) {
                        try {
                          eg.jf.sessionStorage.setItem(ey, JSON.stringify(e));
                        } catch (e) {
                          em.T && l.Yz.warn("Could not store previous trace in sessionStorage", e);
                        }
                      })(a));
                });
                let i = !0;
                r &&
                  e.on("beforeSampling", (e) => {
                    if (!a) return;
                    let t = (0, o.o5)(),
                      r = t.getPropagationContext();
                    if (i && r.parentSpanId) {
                      i = !1;
                      return;
                    }
                    (t.setPropagationContext({
                      ...r,
                      dsc: {
                        ...r.dsc,
                        sample_rate: String(a.sampleRate),
                        sampled: String(ev(a.spanContext)),
                      },
                      sampleRand: a.sampleRand,
                    }),
                      (e.parentSampled = ev(a.spanContext)),
                      (e.parentSampleRate = a.sampleRate),
                      (e.spanAttributes = { ...e.spanAttributes, [s.Ef]: a.sampleRate }));
                  });
              })(e, { linkPreviousTrace: eY, consistentTraceSampling: eX }),
            eg.jf.location)
          ) {
            if (eB) {
              let t = (0, p.k3)();
              eD(e, {
                name: eg.jf.location.pathname,
                startTime: t ? t / 1e3 : void 0,
                attributes: { [s.i_]: "url", [s.JD]: "auto.pageload.browser" },
              });
            }
            ez &&
              (0, e_._)(({ to: t, from: n }) => {
                if (void 0 === n && _?.indexOf(t) !== -1) {
                  _ = void 0;
                  return;
                }
                _ = void 0;
                let a = (0, F.kg)(t),
                  o = e[e$],
                  i =
                    o &&
                    eq &&
                    (function (e, t) {
                      let r = (0, d.et)(e),
                        n = (0, p.lu)();
                      return !(n - r.start_timestamp > 1.5) && (!t || !(n - t <= 1.5));
                    })(o, r);
                eU(
                  e,
                  {
                    name: a?.pathname || eg.jf.location.pathname,
                    attributes: { [s.i_]: "url", [s.JD]: "auto.navigation.browser" },
                  },
                  { url: t, isRedirect: i },
                );
              });
          }
          (A &&
            (eg.jf.document
              ? eg.jf.document.addEventListener("visibilitychange", () => {
                  let e = (0, d.Bk)();
                  if (!e) return;
                  let t = (0, d.zU)(e);
                  if (eg.jf.document.hidden && t) {
                    let e = "cancelled",
                      { op: r, status: n } = (0, d.et)(t);
                    (em.T &&
                      l.Yz.log(
                        `[Tracing] Transaction: ${e} -> since tab moved to the background, op: ${r}`,
                      ),
                      n || t.setStatus({ code: P.TJ, message: e }),
                      t.setAttribute("sentry.cancellation_reason", "document.hidden"),
                      t.end());
                  }
                })
              : em.T &&
                l.Yz.warn(
                  "[Tracing] Could not set up background tab detection due to lack of global document",
                )),
            E &&
              ((t = e),
              (n = T),
              (a = w),
              (i = x),
              (c = f),
              eg.jf.document &&
                addEventListener(
                  "click",
                  () => {
                    let e = "ui.action.click",
                      r = (function (e) {
                        return e[e$];
                      })(t);
                    if (r && ["navigation", "pageload"].includes((0, d.et)(r).op)) {
                      em.T &&
                        l.Yz.warn(
                          `[Tracing] Did not create ${e} span because a pageload or navigation span is in progress.`,
                        );
                      return;
                    }
                    if (
                      (h && (h.setAttribute(s.fs, "interactionInterrupted"), h.end(), (h = void 0)),
                      !c.name)
                    ) {
                      em.T &&
                        l.Yz.warn(
                          `[Tracing] Did not create ${e} transaction because _latestRouteName is missing.`,
                        );
                      return;
                    }
                    h = N(
                      { name: c.name, op: e, attributes: { [s.i_]: c.source || "url" } },
                      { idleTimeout: n, finalTimeout: a, childSpanTimeout: i },
                    );
                  },
                  { capture: !0 },
                )),
            y &&
              (function () {
                let e = Object.keys(ep);
                function t(e) {
                  let t = e.target;
                  if (!t) return;
                  let r = (0, H.Hd)(t),
                    n = Math.round(e.timeStamp);
                  if ((ed.set(n, r), ed.size > 50)) {
                    let e = ed.keys().next().value;
                    void 0 !== e && ed.delete(e);
                  }
                }
                (0, eu.B)() &&
                  e.forEach((e) => {
                    q.j.addEventListener(e, t, { capture: !0, passive: !0 });
                  });
                let r = ({ entries: e }) => {
                  let t = (0, d.Bk)(),
                    r = t && (0, d.zU)(t);
                  e.forEach((e) => {
                    if (!(0, X.tC)(e)) return;
                    let t = e.interactionId;
                    if (null == t || ef.has(t)) return;
                    let n = e.target
                      ? (0, H.Hd)(e.target)
                      : (function (e) {
                          let t = Math.round(e.startTime),
                            r = ed.get(t);
                          if (!r)
                            for (let e = -5; e <= 5; e++) {
                              let n = ed.get(t + e);
                              if (n) {
                                r = n;
                                break;
                              }
                            }
                          return r || "<unknown>";
                        })(e);
                    if (ec.length > 10) {
                      let e = ec.shift();
                      ef.delete(e);
                    }
                    (ec.push(t), ef.set(t, { span: r, elementName: n }));
                  });
                };
                ((0, X.wv)("event", r), (0, X.wv)("first-input", r));
              })(),
            (function (e, t) {
              let {
                  traceFetch: r,
                  traceXHR: n,
                  trackFetchStreamPerformance: a,
                  shouldCreateSpanForRequest: i,
                  enableHTTPTimings: l,
                  tracePropagationTargets: c,
                  onRequestSpanStart: f,
                  onRequestSpanEnd: p,
                } = { ...eM, ...t },
                h = "function" == typeof i ? i : (e) => !0,
                _ = (e) =>
                  (function (e, t) {
                    let r = (0, H.$N)();
                    if (r) {
                      let n, a;
                      try {
                        ((n = new URL(e, r)), (a = new URL(r).origin));
                      } catch {
                        return !1;
                      }
                      let o = n.origin === a;
                      return t ? (0, B.Xr)(n.toString(), t) || (o && (0, B.Xr)(n.pathname, t)) : o;
                    }
                    {
                      let r = !!e.match(/^\/(?!\/)/);
                      return t ? (0, B.Xr)(e, t) : r;
                    }
                  })(e, c),
                g = {},
                y = e.getOptions().propagateTraceparent;
              (r &&
                (e.addEventProcessor(
                  (e) => (
                    "transaction" === e.type &&
                      e.spans &&
                      e.spans.forEach((e) => {
                        if ("http.client" === e.op) {
                          let t = eC.get(e.span_id);
                          t && ((e.timestamp = t / 1e3), eC.delete(e.span_id));
                        }
                      }),
                    e
                  ),
                ),
                a &&
                  (0, eb.B$)((e) => {
                    if (e.response) {
                      let t = eA.get(e.response);
                      t && e.endTimestamp && eC.set(t, e.endTimestamp);
                    }
                  }),
                (0, eb.ur)((e) => {
                  let t = (function (e, t, r, n, a) {
                    if (!e.fetchData) return;
                    let { method: i, url: s } = e.fetchData,
                      l = (0, u.f)() && t(s);
                    if (e.endTimestamp) {
                      let t = e.fetchData.__span;
                      if (!t) return;
                      let r = n[t];
                      r &&
                        (l &&
                          ((function (e, t) {
                            if (t.response) {
                              (0, P.N8)(e, t.response.status);
                              let r = t.response?.headers?.get("content-length");
                              if (r) {
                                let t = parseInt(r);
                                t > 0 && e.setAttribute("http.response_content_length", t);
                              }
                            } else
                              t.error && e.setStatus({ code: P.TJ, message: "internal_error" });
                            e.end();
                          })(r, e),
                          (function (e, t, r) {
                            let n =
                              "object" == typeof r && null !== r ? r.onRequestSpanEnd : void 0;
                            n?.(e, { headers: t.response?.headers, error: t.error });
                          })(r, e, a)),
                        delete n[t]);
                      return;
                    }
                    let { spanOrigin: c = "auto.http.browser", propagateTraceparent: f = !1 } =
                        "object" == typeof a ? a : { spanOrigin: a },
                      p = !!(0, d.Bk)(),
                      h =
                        l && p
                          ? j(
                              (function (e, t, r) {
                                if (e.startsWith("data:")) {
                                  let n = (0, F.zm)(e);
                                  return { name: `${t} ${n}`, attributes: eO(e, void 0, t, r) };
                                }
                                let n = (0, F.kg)(e),
                                  a = n ? (0, F.CH)(n) : e;
                                return { name: `${t} ${a}`, attributes: eO(e, n, t, r) };
                              })(s, i, c),
                            )
                          : new m();
                    if (
                      ((e.fetchData.__span = h.spanContext().spanId),
                      (n[h.spanContext().spanId] = h),
                      r(e.fetchData.url))
                    ) {
                      let t = e.args[0],
                        r = { ...(e.args[1] || {}) },
                        n = (function (e, t, r, n) {
                          var a;
                          let o = eP({ span: r, propagateTraceparent: n }),
                            i = o["sentry-trace"],
                            s = o.baggage,
                            l = o.traceparent;
                          if (!i) return;
                          let u = t.headers || ((0, z.ks)(e) ? e.headers : void 0);
                          if (!u) return { ...o };
                          if (((a = u), "undefined" != typeof Headers && (0, z.tH)(a, Headers))) {
                            let e = new Headers(u);
                            if (
                              (e.get("sentry-trace") || e.set("sentry-trace", i),
                              n && l && !e.get("traceparent") && e.set("traceparent", l),
                              s)
                            ) {
                              let t = e.get("baggage");
                              t ? eS(t) || e.set("baggage", `${t},${s}`) : e.set("baggage", s);
                            }
                            return e;
                          }
                          if (Array.isArray(u)) {
                            let e = [...u];
                            (u.find((e) => "sentry-trace" === e[0]) || e.push(["sentry-trace", i]),
                              n &&
                                l &&
                                !u.find((e) => "traceparent" === e[0]) &&
                                e.push(["traceparent", l]));
                            let t = u.find((e) => "baggage" === e[0] && eS(e[1]));
                            return (s && !t && e.push(["baggage", s]), e);
                          }
                          {
                            let e = "sentry-trace" in u ? u["sentry-trace"] : void 0,
                              t = "traceparent" in u ? u.traceparent : void 0,
                              r = "baggage" in u ? u.baggage : void 0,
                              a = r ? (Array.isArray(r) ? [...r] : [r]) : [],
                              o = r && (Array.isArray(r) ? r.find((e) => eS(e)) : eS(r));
                            s && !o && a.push(s);
                            let c = {
                              ...u,
                              "sentry-trace": e ?? i,
                              baggage: a.length > 0 ? a.join(",") : void 0,
                            };
                            return (n && l && !t && (c.traceparent = l), c);
                          }
                        })(t, r, (0, u.f)() && p ? h : void 0, f);
                      n && ((e.args[1] = r), (r.headers = n));
                    }
                    let _ = (0, o.KU)();
                    if (_) {
                      let t = {
                        input: e.args,
                        response: e.response,
                        startTimestamp: e.startTimestamp,
                        endTimestamp: e.endTimestamp,
                      };
                      _.emit("beforeOutgoingRequestSpan", h, t);
                    }
                    return h;
                  })(e, h, _, g, { propagateTraceparent: y, onRequestSpanEnd: p });
                  if (
                    (e.response && e.fetchData.__span && eA.set(e.response, e.fetchData.__span), t)
                  ) {
                    let r = ej(e.fetchData.url),
                      n = r ? (0, F.Dl)(r).host : void 0;
                    (t.setAttributes({
                      "http.url": r ? (0, F.zm)(r) : void 0,
                      "server.address": n,
                    }),
                      l && eN(t),
                      f?.(t, { headers: e.headers }));
                  }
                })),
                n &&
                  (0, eT.Mn)((e) => {
                    let t = (function (e, t, r, n, a, i) {
                      let l = e.xhr,
                        c = l?.[eT.Er];
                      if (!l || l.__sentry_own_request__ || !c) return;
                      let { url: f, method: p } = c,
                        h = (0, u.f)() && t(f);
                      if (e.endTimestamp) {
                        let t = l.__sentry_xhr_span_id__;
                        if (!t) return;
                        let r = n[t];
                        r &&
                          (h &&
                            void 0 !== c.status_code &&
                            ((0, P.N8)(r, c.status_code),
                            r.end(),
                            i?.(r, { headers: ex((0, ew.ti)(l)), error: e.error })),
                          delete n[t]);
                        return;
                      }
                      let _ = ej(f),
                        g = _ ? (0, F.Dl)(_) : (0, F.Dl)(f),
                        y = (0, F.zm)((0, F.f)(f)),
                        v = !!(0, d.Bk)(),
                        b =
                          h && v
                            ? j({
                                name: `${p} ${y}`,
                                attributes: {
                                  url: (0, F.zm)(f),
                                  type: "xhr",
                                  "http.method": p,
                                  "http.url": _ ? (0, F.zm)(_) : void 0,
                                  "server.address": g?.host,
                                  [s.JD]: "auto.http.browser",
                                  [s.uT]: "http.client",
                                  ...(g?.search && { "http.query": g?.search }),
                                  ...(g?.hash && { "http.fragment": g?.hash }),
                                },
                              })
                            : new m();
                      ((l.__sentry_xhr_span_id__ = b.spanContext().spanId),
                        (n[l.__sentry_xhr_span_id__] = b),
                        r(f) &&
                          (function (e, t, r) {
                            let {
                              "sentry-trace": n,
                              baggage: a,
                              traceparent: o,
                            } = eP({ span: t, propagateTraceparent: r });
                            n &&
                              (function (e, t, r, n) {
                                let a = e.__sentry_xhr_v3__?.request_headers;
                                if (!a?.["sentry-trace"] && e.setRequestHeader)
                                  try {
                                    if (
                                      (e.setRequestHeader("sentry-trace", t),
                                      n && !a?.traceparent && e.setRequestHeader("traceparent", n),
                                      r)
                                    ) {
                                      let t = a?.baggage;
                                      (t &&
                                        t.split(",").some((e) => e.trim().startsWith("sentry-"))) ||
                                        e.setRequestHeader("baggage", r);
                                    }
                                  } catch {}
                              })(e, n, a, o);
                          })(l, (0, u.f)() && v ? b : void 0, a));
                      let E = (0, o.KU)();
                      return (E && E.emit("beforeOutgoingRequestSpan", b, e), b);
                    })(e, h, _, g, y, p);
                    t &&
                      (l && eN(t),
                      f?.(t, { headers: ex(e.xhr.__sentry_xhr_v3__?.request_headers) }));
                  }));
            })(e, {
              traceFetch: C,
              traceXHR: M,
              trackFetchStreamPerformance: W,
              tracePropagationTargets: e.getOptions().tracePropagationTargets,
              shouldCreateSpanForRequest: et,
              enableHTTPTimings: eE,
              onRequestSpanStart: eK,
              onRequestSpanEnd: eG,
            }));
        },
      };
    };
  function eD(e, t, r) {
    (e.emit("startPageLoadSpan", t, r), (0, o.o5)().setTransactionName(t.name));
    let n = e[e$];
    return (n && e.emit("afterStartPageLoadSpan", n), n);
  }
  function eU(e, t, r) {
    let { url: n, isRedirect: a } = r || {};
    (e.emit("beforeStartNavigationSpan", t, { isRedirect: a }),
      e.emit("startNavigationSpan", t, { isRedirect: a }));
    let i = (0, o.o5)();
    return (
      i.setTransactionName(t.name),
      n && !a && i.setSDKProcessingMetadata({ normalizedRequest: { ...(0, eg.AP)(), url: n } }),
      e[e$]
    );
  }
  function eH(e) {
    let t = eg.jf.document,
      r = t?.querySelector(`meta[name=${e}]`);
    return r?.getAttribute("content") || void 0;
  }
  function eF(e) {
    let t = eg.jf.performance?.getEntriesByType?.("navigation")[0],
      r = t?.serverTiming?.find((t) => t.name === e);
    return r?.description;
  }
  let e$ = "_sentry_idleSpan";
}
